import { Deserializable } from '../protocols/deserializable';
import { Attachment } from './attachment';

export class SubmissionAttachment implements Deserializable {
  public id!: string;
  public attachment!: Attachment;
  public uploadedDuringSubmission!: boolean;

  public onDeserialize(): void {
    if (!!this.attachment) {
      this.attachment = window.injector.Deserialize.instanceOf(Attachment, this.attachment);
    }
  }
}
